/**
 * File: apps/qbench-cp/reactapp/src/shared/components/common/Redirect.jsx
 *
 * Purpose: A styled react-router `Link` used as a themed, optionally-disabled text link.
 *
 * Scope: Shared common UI components used across customer portal tables and detail views.
 *
 * Tags: customer-portal
 *
 * Overview: Styles a react-router `Link` with theme-driven link color, optional size, uppercase,
 *     and font-weight props, falling back to a greyed-out color when `disabled` is set. When
 *     `disabled` is true, the click handler is overridden to call `preventDefault()`, keeping the
 *     link visually present but non-navigable. Any additional inline `style` prop is spread onto
 *     the styled rules.
 *
 * Exports: Redirect component (default export).
 */

import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const StyledRedirect = styled(Link) `
    color: ${props => props.disabled ? props.theme.color.palette.grey[500] : props.theme.color.palette.text.link};
    font-size: ${props => props.size ? props.size : '14px'};
    text-transform: ${props => props.uppercase === 'true' ? 'uppercase' : null};
    font-weight: ${props => props.weight ? props.weight : 400};
    ${props => ({...props.style})}
    &:hover {
        color: ${props => props.theme.color.palette.text.link};
    }
`

export default function Redirect({children, ...props}) {

    if (props.disabled) {
        props.onClick = (e) => e.preventDefault();
    }

    return (
        <StyledRedirect {...props} >
            {children}
        </StyledRedirect>
    )
}